/**
 * VerifyForm Component
 * 
 * Displays the account activation form where users confirm they agree to
 * terms of service, privacy policy, cookies, and user notice before activating
 * their account.
 * 
 * @param {Object} props - Component props
 * @param {string} props.response - Response message/alert to display
 * @param {Function} props.handleConfirm - Callback to confirm and activate account\n * @param {string} props.token - Authentication token from URL\n * @param {string} props.tokenId - Token ID from URL\n * @returns {JSX.Element} Account activation confirmation form\n */
import React from 'react'
import './verify-form.css'
import { Card, Button } from 'react-bootstrap'
import HeaderLogo from '../../../assets/navbar/roiquant-600x200px-white-01.png';

/**
 * The VerifyForm component renders a card for activating a roiquant account with a button to agree and
 * confirm.
 * @param props - Props in React are used to pass data from a parent component to a child component. In
 * the `VerifyForm` component, the `props` parameter is an object that contains any properties passed
 * down to the component from its parent component. These properties can include data, functions, or
 * any other values that
 * @returns The VerifyForm component is being returned. It contains JSX elements for displaying a
 * verification form with a card layout, including a header, extra notes, and a button for confirming
 * the activation of a roiquant account. The component also displays a response message passed as a
 * prop.
 */

function VerifyForm(props) {

  return (
    <div id="verifycontent">

      <div className="verifytop">
        <a href="https://www.roiquant.com/" target="_blank" rel="noopener noreferrer">
          <img src={HeaderLogo} alt="roiquant" width="180px" height="60px" className="roiquantlogo" />
        </a>
      </div>

      <div>{props.response}</div>

      <div id="verifyform">
        <Card className="verifycard">
          <div className="verifyheader">
            <h3>Activate your roiquant account</h3>
          </div>

          <div className="extranote">
            {/* User must agree to terms of service, privacy policy, etc. before activation */}
            <span>
              By clicking below, you agree to roiquant's <a href="https://viewpoints.roiquant.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                privacy policy</a>, <a href="https://viewpoints.roiquant.com/how-do-we-use-cookies/" target="_blank" rel="noopener noreferrer">
                cookies</a>, <a href="https://viewpoints.roiquant.com/user-notice/" target="_blank" rel="noopener noreferrer">
                user notice</a> and <a href="https://viewpoints.roiquant.com/terms-of-service/" target="_blank" rel="noopener noreferrer">
                terms of service</a>.
            </span>
          </div>
          <div style={{ textAlign: "center" }}>
            {/* Button to confirm agreement and activate account */}
            <Button className="verifybtn glintanimation" onClick={() => { props.handleConfirm(props.token, props.tokenId); }}>
              <span>Agree & confirm</span>
            </Button>
          </div>

        </Card>
      </div>
    </div>
  )
}

export default VerifyForm